<template>
  <div class="enhancify grid-module">
    <div class="header">
      <h2>News & Updates</h2>
      <div class="grid-module__filter news-and-updates" v-on:keyup.enter="doSearch">
        <div class="box-filter_parent">
          <div class="box-filter_child box-filter_child_pr">
            <b-field grouped position="is-left boxfilter-fullwidth">
              <div class="field is-grouped fullwidth box-filter_fullwidth"
                   >
                <b-field calss="boxfilter-inherit" style="margin-bottom: 0px;width: inherit;">
                  <b-input
                      placeholder="Search by notes..."
                      customClass="boxfilter-input"
                      v-model.trim="searchText"
                      rootClasses="boxfilter-input"
                      class="boxfilter-input search-input"
                      type="search"
                      inheritAttrs=true>
                  </b-input>
                  <p class="control">
                    <b-button
                        icon-right="magnify"
                        class="is-success gobtn"
                        @click="doSearch"
                    ></b-button>
                  </p>
                </b-field>
              </div>
            </b-field>
          </div>
          <div class="box-filter_child box-filter_child_pr">
            <b-field grouped position="is-left">
              <span class="type-title label control">Recipient:</span>
              <b-select v-model="recipient" expanded
                        @input="doSearch">
                <option
                    v-for="option in recipients"
                    :value="option.value"
                    :key="option.value">
                  {{ option.text }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="box-filter_child">
            <div class="modern-input-labeled">
              <label for="startedFilter">Create date</label>
              <ModernDateSelect
                  :options="dateSelectOptions"
                  id="startedFilter"
                  ref="modernDateSelect"
                  v-model="startedFilter" />
            </div>
          </div>
          <div class="box-filter_child right">
            <b-button
                class="lead-distribution-add-set-btn is-success"
                @click="onAddNoteClick">
              ADD NOTE
            </b-button>
          </div>
        </div>
      </div>
    </div>

      <div class="grid-module__grid">
        <b-table
            :data="newsAndUpdates"
            :loading="tableIsLoading"
            :default-sort="[defaultSort, defaultSortDirection]"
            :total="total"
            :per-page="perPage"
            :current-page.sync="page"
            paginated
            hoverable
            sticky-header
            backend-sorting
            backend-pagination
            class="bordered-table"
            @page-change="onPageChange"
            @sort="onSort"
            ref="tbl"
        >
          <template v-slot="props">
            <b-table-column label="Release note" width="50%">
              <template #header="column">
                <div class="enhtableth" :class=column.column.thclass>
                  <span class="enhlabel">{{ column.column.label }}</span>
                </div>
              </template>
              <div class="release-note-data-wrapper">
                <span class="delete-caption" v-if="props.row.deleted">[DELETE] </span>
                <span :class="{'release-note-deleted': props.row.deleted}"
                      class="ellipsis cell__value" v-html="props.row.releaseNote">
              </span>
              </div>
            </b-table-column>
            <b-table-column :class="{'release-note-deleted': props.row.deleted}"
                            width="25%"
                            label="Recipient">
              <template #header="column">
                <div class="enhtableth" :class=column.column.thclass>
                  <span class="enhlabel">{{ column.column.label }}</span>
                </div>
              </template>
              <div class="recipient-data-wrapper">
                <div v-if="getContractorTiers(props.row.recipient).length > 0"
                     v-html="getContractorTiers(props.row.recipient)">
                </div>
                <div v-html="getAdditionalUserInfo(props.row.recipient)">
                </div>
                <div v-if="getManager(props.row.recipient)">
                  <span><b>Manager</b></span>
                </div>
              </div>
            </b-table-column>
            <b-table-column :class="{'release-note-deleted': props.row.deleted}"
                            label="Create date"
                            width="10%"
                            field="createDate" sortable>
              <template #header="column">
                <div class="enhtableth" :class=column.column.thclass>
                  <span class="enhlabel">{{ column.column.label }}</span>
                </div>
              </template>
              <span class="cell__value">{{ props.row.createDate }}</span>
            </b-table-column>
            <b-table-column :class="{'release-note-changed': props.row.lastEditDate
            !== props.row.createDate}"
                            label="Last edit date"
                            width="10%"
                            field="lastEditDate" sortable>
              <template #header="column">
                <div class="enhtableth" :class=column.column.thclass>
                  <span class="enhlabel">{{ column.column.label }}</span>
                </div>
              </template>
              <span class="cell__value">{{ props.row.lastEditDate }}</span>
            </b-table-column>
            <b-table-column class="cell news-and-updates-manage-column"
                            width="5%"
                            cell-class="action-data-column">
              <div class="actions-wrapper">
                <span v-if="!props.row.deleted"
                      title="Edit release note" class="icon is-success action-button"
                      @click="onEdit(props.row)">
                  <i class="fas fa-pencil-alt fa-lg"></i>
                </span>
                <span title="Copy release note" class="icon is-success action-button"
                      @click="onCopy(props.row)">
                  <i class="far fa-clone fa-rotate-90 fa-lg"></i>
                </span>
                <span v-if="!props.row.deleted"
                      title="Delete release note" class="icon is-success action-button"
                      @click="onRemove(props.row)">
                  <i class="far fa-trash-alt fa-lg"></i>
                </span>
              </div>
            </b-table-column>
          </template>
          <template v-slot:bottom-left>
            <b-field label="Per page" horizontal style="margin-right: 1rem" class="enh-per-page">
              <b-select v-model="perPage" @input="doSearch" :disabled="newsAndUpdates.length === 0">
                <option
                    v-for="perPageOption in perPageOptions"
                    :key="perPageOption"
                    :value="perPageOption"
                    :selected="perPageOption === perPage"
                >{{ perPageOption }}
                </option>
              </b-select>
            </b-field>
          </template>
          <template slot="empty">
            <div v-if="newsAndUpdates.length === 0" class="columns is-centered" style="margin: 0;">
              <div class="column is-half enh-disabled has-text-centered">
                <b-icon pack="fal" icon="frown" size="is-large"></b-icon>
                <p>Nothing here</p>
              </div>
            </div>
          </template>
        </b-table>
      </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import * as MUTATIONS from '@/store/mutations';
import {
  postNewsAndUpdates,
  getNewsAndUpdates,
} from '@/api/settings';
import Vue from 'vue';
import { RANGE } from '@/const/constants';
import { getRange } from '@/utils/range';
import ModernDateSelect from '@/components/ModernDateSelect.vue';
import dayjs from 'dayjs';
import NewsAndUpdates from '@/components/Modal/NewsAndUpdates.vue';
import _ from 'lodash';

export default {
  components: {
    ModernDateSelect,
  },
  name: 'NewsAndUpdated',
  watch: {
    watchFilters() {
      this.doSearch();
    },
  },
  computed: {
    watchFilters() {
      return [this.recipient, this.startedFilter];
    },
    getContractorTiers() {
      return (recipient) => {
        if ('contractor' in recipient && recipient.contractor) {
          let info = '';
          if ('tiers' in recipient.contractor && recipient.contractor.tiers.length > 0) {
            info = recipient.contractor.tiers.join(', ');
          }
          if (info.length === 0) {
            info = 'any';
          }
          return `<span><b>Contractor</b> (${info})</span>`;
        }
        return '';
      };
    },
    getAdditionalUserInfo() {
      return (recipient) => {
        if ('additionalUser' in recipient && recipient.additionalUser) {
          let info = '';
          if ('tiers' in recipient.additionalUser && recipient.additionalUser.tiers.length > 0) {
            info = `tier: ${recipient.additionalUser.tiers.join(', ')}`;
          }
          if ('sections' in recipient.additionalUser && recipient.additionalUser.sections.length > 0) {
            if (info.length !== 0) info += '; ';
            info += `section: ${recipient.additionalUser.sections.join(', ')}`;
          }
          if (info.length === 0) {
            info = 'any';
          }
          return `<span><b>Additional user</b> (${info})</span>`;
        }
        return '';
      };
    },
    getManager() {
      return (recipient) => {
        if ('manager' in recipient) {
          return recipient.manager;
        }
        return false;
      };
    },
  },
  data() {
    return {
      newsAndUpdates: [],
      tableIsLoading: false,
      searchText: '',
      sortField: 'lastEditDate',
      sortOrder: 'desc',
      defaultSort: 'lastEditDate',
      defaultSortDirection: 'desc',
      recipients: [
        { value: 'any', text: 'Any' },
        { value: 'contractor', text: 'Contractor' },
        { value: 'additionalUser', text: 'Additional user' },
        { value: 'manager', text: 'Manager' },
      ],
      recipient: 'any',
      page: 1,
      perPage: 25,
      perPageOptions: [10, 25, 50, 100],
      startedFilter: { selectedRange: RANGE.LAST_30_DAYS, ...getRange(RANGE.LAST_30_DAYS) },
      dateSelectOptions: [
        { value: RANGE.TODAY, label: 'Today' },
        { value: RANGE.LAST_30_DAYS, label: 'Last 30 days' },
        { value: RANGE.LAST_365_DAYS, label: 'Last 365 days' },
        { value: RANGE.CUSTOM, label: 'Custom' },
      ],
      total: 0,
    };
  },
  async activated() {
    this.doSearch();
  },

  methods: {
    ...mapMutations({
      startLoading: MUTATIONS.START_LOADING,
      finishLoading: MUTATIONS.FINISH_LOADING,
    }),
    async onEdit(row) {
      this.startLoading();
      const Component = Vue.extend(NewsAndUpdates);
      await this.$buefy.modal.open({
        parent: this,
        component: Component,
        hasModalCard: true,
        trapFocus: true,
        scroll: 'keep',
        ariaModal: true,
        customClass: 'card-form-modal',
        canCancel: ['outside'],
        props: {
          releaseNote: row,
        },
        events: {
          submit(response) {
            const { context, updatedData } = response;
            const index = context.$parent.$parent.newsAndUpdates.findIndex(
              (item) => item.id === row.id,
            );
            if (index > -1 && updatedData) {
              context.$parent.$parent.newsAndUpdates[index].releaseNote = updatedData.releaseNote;
              context.$parent.$parent.newsAndUpdates[index].recipient = updatedData.recipient;
              context.$parent.$parent.newsAndUpdates[index].lastEditDate = updatedData.lastEditDate;
            }
          },
        },
      });
      this.changeModalPosition();
      this.finishLoading();
    },
    async onCopy(row) {
      this.startLoading();
      const Component = Vue.extend(NewsAndUpdates);
      await this.$buefy.modal.open({
        parent: this,
        component: Component,
        hasModalCard: true,
        trapFocus: true,
        scroll: 'keep',
        ariaModal: true,
        customClass: 'card-form-modal',
        canCancel: ['outside'],
        props: {
          releaseNote: row,
          copying: true,
        },
        events: {
          submit(response) {
            const { context } = response;
            context.$parent.$parent.doSearch();
          },
        },
      });
      this.changeModalPosition();
      this.finishLoading();
    },
    async onRemove(row) {
      await this.$buefy.dialog.confirm({
        title: 'Deleting release note',
        message: 'Are you sure you want to <b>delete</b> this release note? This action cannot be undone.',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        ariaModal: true,
        onConfirm: async () => {
          this.loading = true;
          const payload = {
            id: row.id,
            deleted: true,
          };
          await postNewsAndUpdates(payload)
            .then((response) => {
              if (response.data.deleted) {
                this.$buefy.toast.open({ message: 'Delete successful!', type: 'is-success', duration: 3000 });
                const index = this.newsAndUpdates.findIndex((item) => item.id === row.id);
                this.newsAndUpdates[index].deleted = 1;
                this.newsAndUpdates[index].lastEditDate = response.data.lastEditDate;
              }
            })
            .catch((err) => {
              const error = _.get(err, 'response.data.error', null);
              const message = _.get(err, 'response.data.message', 'An unexpected error occurred, please contact support@enhancify.com');
              if (error) {
                this.$buefy.toast.open({ message, type: 'is-danger', duration: 3000 });
              } else {
                this.$buefy.toast.open({ message: 'An unexpected error occurred, please contact support@enhancify.com' });
              }
            })
            .finally(() => {
              this.finishLoading();
            });
        },
      });
    },
    doSearch() {
      this.loadAsyncData();
    },
    async onAddNoteClick() {
      const Component = Vue.extend(NewsAndUpdates);
      await this.$buefy.modal.open({
        parent: this,
        component: Component,
        hasModalCard: true,
        trapFocus: true,
        scroll: 'keep',
        ariaModal: true,
        customClass: 'card-form-modal',
        canCancel: ['outside'],
        events: {
          submit(response) {
            const { context } = response;
            context.$parent.$parent.doSearch();
          },
        },
      });
      this.changeModalPosition();
    },
    async loadAsyncData() {
      this.loading = true;
      const queryParams = {
        order: `${this.sortOrder === 'desc' ? '-' : '+'}${this.sortField}`,
        page: this.page,
        limit: this.perPage,
        search: this.searchText,
        recipient: this.recipient,
        'started[gte]': dayjs(this.startedFilter.from).format('YYYY-MM-DD'),
        'started[lte]': dayjs(this.startedFilter.to).format('YYYY-MM-DD'),
      };
      if (this.searchText === '') delete queryParams.search;
      if (this.recipient === 'any') delete queryParams.recipient;
      try {
        const { data } = await getNewsAndUpdates(queryParams);
        this.newsAndUpdates = data.data;
        this.total = data.total;
      } finally {
        this.loading = false;
      }
    },
    onPageChange(page) {
      this.page = page;
      this.loadAsyncData();
    },
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.loadAsyncData();
    },
    changeModalPosition() {
      const grid = document.querySelector('.grid-module');
      const modal = document.querySelector('.modal');
      if (grid && modal) {
        grid.insertAdjacentElement('beforeend', modal);
      }
    },
  },

};
</script>

<style lang="stylus" scoped>
@import "~@/assets/style/views/Manage/Settings/table.styl";

.recipient-data-wrapper
  width 80%
.header h2
  margin-bottom 10px
.grid-module__filter.news-and-updates
  padding-top 0

.release-note-changed
  color #4C7B93
.delete-caption
  color #DE4B4B
.release-note-deleted
  color #BDBDBD!important
  & >>> *
    color #BDBDBD!important

.modern-input-labeled
  width 100%
</style>
